import { defineStore } from 'pinia'
import ApplianceService from '../service/ApplianceService';
const applianceService = new ApplianceService();
export const useApplianceStore = defineStore({
  id: 'appliance',
  state: () => ({
    appliances: [],
    appliance: {},
    map: {},
    loading: false,
    error: null,
    filters: [],
    sort_object: null,
    paginator_page: 1,
    paginator_size: 50,
    paginator_first: 1,
    activeIndex: 0,
  }),
  getters: {
    getAppliances: (state) => {
      return state.appliances;
    },
    getAppliance: (state) => {
      return state.appliance;
    },
    getMap: (state) => {
      return state.map;
    },
    getAppliancesListFilters: (state) => {
      return state.filters;
    },
    getAppliancesSortObject: (state) => {
      return state.sort_object;
    },
    getAppliancesPaginatorPage: (state) => {
      return state.paginator_page;
    },
    getAppliancesPaginatorSize: (state) => {
      return state.paginator_size;
    },
    getAppliancesPaginatorFirst: (state) => {
      return state.paginator_first;
    },
    getActiveIndex: (state) => {
      return state.activeIndex;
    }
  },
  actions: {
    setAppliancesSortObject(sort_object) {
      this.sort_object = sort_object;
    },
    setAppliancesListFilters(list_filters) {
      this.filters = list_filters;
    },
    setMap(map) {
      this.map = map;
    },
    setAppliancesPaginatorPage(paginator_page) {
      this.paginator_page = paginator_page;
    },
    setAppliancesPaginatorSize(paginator_size) {
      this.paginator_size = paginator_size;
    },
    setAppliancesPaginatorFirst(paginator_first) {
      this.paginator_first = paginator_first;
    },
    async setEmptyAplliance() {
      this.appliance = null;
    },
    filtersParser(filters) {
      let result = [];
      let equals_list = ["registration_status", "connection_status"];
      let between_list = ["registration_time"];
      let in_list = ["tags"];
      filters.forEach(filter => {
        if (filter && Object.keys(filter).length !== 0) {
          let operator = equals_list.includes(filter.key) ? "=" : between_list.includes(filter.key) ? "BETWEEN" : 
              in_list.includes(filter.key) ? "IN_LIST" : "CONTAINS";
          let attribute = filter.key === "tags" ? "tag_list" : filter.key
          let value = filter.key === "tags" ? filter.value.split(",").map((item) => item.trim()) : filter.value
          if(["mac_address","mac-address"].includes(attribute)) {
            value = value.replace(/:/g,"");
          }
          result.push({
            "attribute": attribute,
            "value": value,
            "operator": operator
          });
        }
      });
      return result;
    },
    setAppliances() {
      this.appliances = [];
    },
    setAppliance() {
      this.appliance = {}
    },
    async fetchAppliances(limit = 10, offset = 0, filters = [], sortObject, select = [], count = true, count_attr = "registration_time") {
      this.appliances = []
      this.loading = true
      try {
        let filtersParsed = this.filtersParser(filters);
        this.appliances = await applianceService.fetchAppliances(limit, offset, filtersParsed, sortObject, select, count, count_attr)
          .then((response) => response)
        return this.appliances;
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    },
    async fetchAppliance(id = null) {
      this.loading = true
      try {
        this.appliance = await applianceService.fetchAppliance(id)
          .then((response) => response)
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    },
    async fetchUnclaimAppliance(id, router) {
      try {
        await applianceService.fetchUnclaimAppliance(id)
          .then((response) => response.items)
      } catch (error) {
        this.error = error
      } finally {
        router.push({
          name: "Appliances",
        });
      }
    },
    getAppliancesListFiltersParsed(filters) {
      let result = this.filtersParser(filters);
      return result;
    },

    async updateFirmware(appliance, confirmation, version) {
      this.appliances = []
      this.loading = true
      try {
        return await applianceService.updateFirmware(appliance, confirmation, version)
          .then((response) => response)
      } catch (error) {
        this.error = error.message
        return { ...error.response.data, httpStatus: error.response.status};
      } finally {
        this.loading = false
      }
    },
    
    async fetchFirmwareHistory(claimerEndUserCode, deviceCode) {
      this.loading = true;
      try {
        return await applianceService.fetchFirmwareHistory(claimerEndUserCode, deviceCode)
          .then((response) => response)
      } catch (error) {
        this.error = error
      } finally {
        this.loading = false
      }
    },

    liveUpdateAppliances(data) {
      console.info("liveUpdateAppliances", data);
      if(this.appliances?.items) {
        for(let i=0; i<this.appliances.items.length; i++) {
          if(this.appliances.items[i].id == data.deviceCode) {
            this.internalLiveUpdate(this.appliances.items[i], data);
            break;
          }
        }
      }
    },
    liveUpdateSingleAppliance(data) {
      console.info("liveUpdateSingleAppliance", data);
      if(this.appliance?.id == data.deviceCode) {
        this.internalLiveUpdate(this.appliance, data);
      }
    },
    
    internalLiveUpdate(appl, data) {
      console.info("internalLiveUpdate", data);
      if(data.status.online!=null) {
        appl.connection_status = data.status.online;
        delete data.status.online; //rimuovo la chiave online dallo status
      }
      if(data.status.alarms!=null) {
        appl.alarms = data.status.alarms;
        delete data.status.alarms; //rimuovo la chiave online dallo status
      }
      if(data.status.warnings!=null) {
        appl.warnings = data.status.warnings;
        delete data.status.warnings; //rimuovo la chiave online dallo status
      }
      appl.status = {...appl.status, ...data.status};
    },

    setActiveIndex(index) {
      this.activeIndex = index;
    },

    fetchVerboseAppliances(limit, offset, filters) {
      return applianceService.fetchVerboseAppliances(limit, offset, filters);
    },
    
    fetchVerboseSingleAppliance(limit, offset, activationCode) {
      return applianceService.fetchVerboseSingleAppliance(limit, offset, activationCode);
    }


  }
});